import React from 'react';
import logoSvg from '../../../images/goldshell.svg';

const Logo = () => {
  return (
    <div className="logo-container">
      <img src={logoSvg} alt="Logo" className="logo w-8" />
    </div>
  );
};

export default Logo;
